import React from "react";
import { Description } from "@ddm-design-system/typography";
import { SecondaryButton } from "@ddm-design-system/button";
import SVGButtonPress from "./assets/button-press";
import useContent from "../../../hooks/useContent";
import { IControlUnit } from "../../../store/installation/types";

interface ICleanInfoProps {
  controlUnit: IControlUnit;
}

const CleanInfo: React.FC<ICleanInfoProps> = ({ controlUnit }) => {
  const { managerAppCommon: common, managerAppControlUnit: content } = useContent();
  const { id } = controlUnit;

  return (
    <div className="cuf-info-wrapper cuf-step-common">
      <div className="cuf-content centered">
        <Description>{content.manager_app_cu_clean_info_how_to}</Description>
        <SVGButtonPress />
      </div>
      <label className="label-for" htmlFor={id}>
        <SecondaryButton className="pointless-button">{common.common_cancel}</SecondaryButton>
      </label>
    </div>
  );
};

export default CleanInfo;
